import { Link, useNavigate } from "react-router-dom";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import { useContext, useEffect, useState } from "react";
import SidBarClient from "./SideBarClient";
import { MagasinContext } from "../../../Context/MagasinContext";
import DefaulteImage from "../../Admin/IMG/3.png";
import axios from "axios";
import "../visiteur/Homevisiteur.css"; // Import the exact visitor card styles
import "./homeclient.css";
import './PremiumButton.css';
import EmptyCartPopup from "../../../components/EmptyCartPopup";
import BugReportButton from "../../../components/BugReportButton";
import Timer from "../../../components/Timer";


interface Product {
  id: string;
  name: string;
  imageUrl: string;
  price: string;
  PrixNetHT?: string;
  ref?: any;
  vendeur?: string;
  quantity: number;
}

/* ── commission helpers ── */
function resolveGlobalCommission(rules: any[]): number {
  const glob = rules.find((r: any) => r.commission_type === 'global');
  return glob ? parseFloat(glob.commission_value) || 0 : 0;
}
function calcFinalPrice(prixHT: number, globalPct: number, remisePct: number): number {
  // Prix final = prix_original × (1 + commission_globale%) × (1 + remise%) × (1 - remise%)
  // Exemple: 131.52 × 1.03 × 1.05 × 0.95 = 135.12
  if (remisePct <= 0) return prixHT * (1 + globalPct / 100);
  const old = prixHT * (1 + globalPct / 100) * (1 + remisePct / 100);
  return old * (1 - remisePct / 100);
}
function calcOldPrice(prixHT: number, globalPct: number, remisePct: number): number {
  // Prix ancien (barré) = prix_original × (1 + commission_globale%) × (1 + remise%)
  // Exemple: 131.52 × 1.03 × 1.05 = 142.23
  if (remisePct <= 0) return prixHT * (1 + globalPct / 100);
  return prixHT * (1 + globalPct / 100) * (1 + remisePct / 100);
}

export default function AllProductClient() {
  const magasinContext = useContext(MagasinContext);
  const ClientId = localStorage.getItem('ClientId');
  const ClientName = localStorage.getItem('ClientName');
  const idClient = ClientId || magasinContext.id?.id;

  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState<ArticleInfo[]>([]);
  const [magasinProducts, setMagasinProducts] = useState<any[]>([]);
  const [assignedMagasinId, setAssignedMagasinId] = useState<string | null>(null);
  const [assignedMagasinName, setAssignedMagasinName] = useState<string>(localStorage.getItem('MagasinLieeName') || '');
  const [shopFilter, setShopFilter] = useState<string>("tout les produits");
  const [commissionRules, setCommissionRules] = useState<any[]>([]);
  const [clientRemise, setClientRemise] = useState<number>(0);

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);
  const [cartLength, setCartLength] = useState(0);
  const navigate = useNavigate();

  // Load cart length initially and listen for updates
  useEffect(() => {
    const stored = localStorage.getItem('productsClient');
    if (stored) {
      try {
         setCartLength(JSON.parse(stored).length);
      } catch {}
    }
    
    const handleCartUpdate = () => {
      const updated = localStorage.getItem('productsClient');
      if (updated) {
        try {
           setCartLength(JSON.parse(updated).length);
        } catch {}
      } else {
        setCartLength(0);
      }
    };
    window.addEventListener("panier-updated", handleCartUpdate);
    return () => window.removeEventListener("panier-updated", handleCartUpdate);
  }, []);

  /* ── fetch commission rules ── */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`)
      .then(r => setCommissionRules(r.data || []))
      .catch(() => setCommissionRules([]));
  }, []);

  /* ── fetch client remise ── */
  useEffect(() => {
    if (!ClientId) return;
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${ClientId}/profile`)
      .then(res => {
        const c = res.data?.client;
        if (c) {
          const r = parseFloat(c.RemiseGlobal ?? c.RemiseGlobale ?? "0");
          setClientRemise(isNaN(r) ? 0 : r);
        }
      })
      .catch(() => {});
  }, [ClientId]);

  // Unified CartTimer handles the expiration via localStorage

  // Quantity Management for each card
  const [cardQuantities, setCardQuantities] = useState<{ [id: string]: number }>({});
  const [addedToCart, setAddedToCart] = useState<{ [id: string]: boolean }>({});
  const [addingToCartId, setAddingToCartId] = useState<string | null>(null);

  const getQuantity = (id: string) => cardQuantities[id] ?? 1;
  
  const changeQuantity = (id: string, delta: number) => {
    setCardQuantities(prev => {
      const next = Math.max(1, (prev[id] ?? 1) + delta);
      return { ...prev, [id]: next };
    });
  };

  const handleAddToCart = async (pro: any) => {
    const baseId = pro.IdArticle ?? pro.id ?? pro.idArticle ?? '';
    const id = baseId.toString() + '_' + (pro.NomMagasin ?? 'global');
    if (!id || id === '_global') return;
    
    const qty = getQuantity(id);
    setAddingToCartId(id);

    try {
      const rawHT = parseFloat(String(pro.PrixNetHT ?? pro.PrixVenteTTC ?? pro.PrixTTC ?? pro.PrixVente ?? "0").replace(",", "."));
      const globalPct = resolveGlobalCommission(commissionRules);
      const finalPrice = isNaN(rawHT) ? 0 : calcFinalPrice(rawHT, globalPct, clientRemise);
      const finalRef = pro.RefArticle || pro.ref || pro.Ref || id;
      const finalName = pro.Designation || pro.name || pro.NomArticle || "Article";
      const finalImg = pro.urlImage || pro.image || pro.Image || DefaulteImage;
      const finalNomMag = pro.NomMagasin || "Magasin";

      // 1. Post to backend /panier
      const formData = new FormData();
      formData.append("IdUtilisateur", idClient || '');
      formData.append("IdClient", idClient || '');
      formData.append("TypeUtilisiteur", "clients");
      formData.append("IdArticle", String(pro.IdArticle || pro.id || baseId));  // real article ID
      formData.append("RefArticle", finalRef);
      formData.append("Designation", finalName);
      formData.append("Image", finalImg);
      formData.append("price", finalPrice.toString());
      formData.append("quantity", qty.toString());
      formData.append("NomMagasin", finalNomMag);
      formData.append("seller", finalNomMag);

      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier`, formData);
      localStorage.setItem('cartExpiration', String(Date.now() + 50 * 60 * 1000)); // 50 minutes

      // 2. Save/Update in frontend local storage
      let localCart: Product[] = [];
      const stored = localStorage.getItem('productsClient');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          localCart = Array.isArray(parsed) ? parsed : [];
        } catch {
          localCart = [];
        }
      }

      const existingIndex = localCart.findIndex(item => item.id === id);
      if (existingIndex !== -1) {
        localCart[existingIndex].quantity += qty;
      } else {
        localCart.push({
          id: id,
          name: finalName,
          imageUrl: finalImg,
          price: finalPrice.toString(),
          PrixNetHT: finalPrice.toString(),
          quantity: qty,
          ref: finalRef,
          vendeur: finalNomMag,
        });
      }

      localStorage.setItem('productsClient', JSON.stringify(localCart));
      
      // Dispatch update event for header/sidebars to refresh
      window.dispatchEvent(new Event("panier-updated"));

      // Start counter timer if empty before
      if (!localStorage.getItem("StartDate")) {
        localStorage.setItem("StartDate", new Date().toISOString());
      }

      setAddedToCart(prev => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setAddedToCart(prev => ({ ...prev, [id]: false }));
      }, 2500);

    } catch (err) {
      console.error("Error adding to cart", err);
    } finally {
      setAddingToCartId(null);
    }
  };

  // Get assigned Magasin ID on mount
  useEffect(() => {
    if (!idClient) return;
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${idClient}/magasin`)
      .then(res => {
        if (res.data && res.data.IdMagasin) {
          setAssignedMagasinId(res.data.IdMagasin.toString());
        }
        if (res.data?.NomMagasin) {
          setAssignedMagasinName(res.data.NomMagasin);
          localStorage.setItem('MagasinLieeName', res.data.NomMagasin);
        }
      })
      .catch(err => {
        console.error("Error loading client's assigned magasin", err);
      });
  }, [idClient]);

  const fetchArticles = async (page = 1, query = "", filterMag = shopFilter) => {
    setLoading(true);
    try {
      const magParam = filterMag === "Mes Produits" ? (assignedMagasinName || localStorage.getItem('MagasinLieeName') || '') : '';
      if (query.trim() !== "") {
        // Query paginated backend search articles
        const res = await axios.get(
          `${process.env.REACT_APP_PHP_APP_URL}/search-articles`,
          {
            params: {
              q: query,
              page: page,
              perPage: 12,
              ...(magParam ? { magasinName: magParam } : {})
            }
          }
        );
        setProducts(res.data.data || []);
        setCurrentPage(res.data.current_page || 1);
        setTotalPages(res.data.total_pages || 1);
      } else {
        // Query paginated default top articles
        const res = await axios.get(
          `${process.env.REACT_APP_PHP_APP_URL}/topArticles`,
          {
            params: {
              page: page,
              perPage: 12,
              ...(magParam ? { magasinName: magParam } : {})
            }
          }
        );
        setProducts(res.data.data || []);
        setCurrentPage(res.data.current_page || 1);
        setTotalPages(res.data.total_pages || 1);
      }
    } catch (err) {
      console.error("Error fetching articles", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles(1, search, shopFilter);
  }, [assignedMagasinName, shopFilter]);

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const val = searchInput.trim();
      setSearch(val);
      setCurrentPage(1);
      fetchArticles(1, val);
    }
  };

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearchInput(val);
    if (val.trim() === '') {
      setSearch('');
      setCurrentPage(1);
      fetchArticles(1, '');
    }
  };

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    fetchArticles(page, search);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };



  return (
    <div className="client-dashboard-wrapper">
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      <SidBarClient />

      <main className="client-main-content">
        {/* Header */}
        <div className="client-header">
          <div>
            <h1 className="client-header-title">
              Catalogue <span>d'Équipements</span>
            </h1>
            <p className="client-header-subtitle">
              Recherchez et parcourez l'ensemble des pièces disponibles avec pagination fluide.
            </p>
          </div>
        </div>



        {/* Store Filter Buttons */}
        <div className="d-flex gap-2 mb-3 flex-wrap">
          {[
            { v: "tout les produits", l: "Tous les produits" },
            { v: "Mes Produits", l: "Mes Produits" },
          ].map(({ v, l }) => (
            <button
              key={v}
              onClick={() => { setShopFilter(v); setCurrentPage(1); }}
              className="px-3 py-2 rounded-3 border fw-semibold"
              style={{
                fontSize: '0.85rem', cursor: 'pointer', transition: 'all .15s',
                background: shopFilter === v ? '#F5A623' : '#fff',
                color: shopFilter === v ? '#fff' : '#334155',
                borderColor: shopFilter === v ? '#F5A623' : '#CBD5E1',
                boxShadow: shopFilter === v ? '0 2px 6px rgba(245, 166, 35, 0.3)' : 'none'
              }}
            >
              {l}
            </button>
          ))}
        </div>

        {/* Search Input */}
        <div className="client-search-box mb-4">
          <i className="bi bi-search client-search-icon"></i>
          <input
            type="text"
            value={searchInput}
            onChange={handleSearchInput}
            onKeyDown={handleSearchKeyDown}
            className="client-search-input"
            placeholder="Rechercher... (appuyez Entrée)"
          />
        </div>

        {/* Loading Spinner */}
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2 text-muted">Chargement des articles...</p>
          </div>
        ) : (
          <>
            {products.length > 0 ? (
              <>
                {/* Products Grid using the exact HomeVisiteur layout & cards */}
                <div className="product-grid-row-hvu">
                  {products.map((pro) => {
                    const rawHT = parseFloat(String(pro.PrixNetHT ?? pro.PrixVenteArticleTTC ?? pro.PrixVente ?? pro.Prix ?? "0").replace(",", ".").trim()) || 0;
                    const globalPct = resolveGlobalCommission(commissionRules);
                    const computedPrice = isNaN(rawHT) ? 0 : calcFinalPrice(rawHT, globalPct, clientRemise);
                    const cleanPrice = computedPrice.toFixed(2);
                    const baseId = pro.IdArticle ?? pro.id ?? '';
                    const id = baseId.toString() + '_' + (pro.NomMagasin ?? 'global');
                    // Old price (shown crossed-out when remise > 0)
                    const oldPrice = isNaN(rawHT) ? 0 : calcOldPrice(rawHT, globalPct, clientRemise);
                    const showOldPrice = clientRemise > 0 && rawHT > 0;
                    
                    // Robust quantity extraction
                    const qtyKey = Object.keys(pro).find(k => k.toLowerCase().startsWith('quantit') || k.toLowerCase() === 'qte' || k.toLowerCase() === 'stock');
                    const availableQty = qtyKey ? Number(pro[qtyKey]) : 0;
                    const outOfStock = isNaN(availableQty) ? true : availableQty <= 0;

                    const finalImg = pro.urlImage || pro.image || pro.Image || DefaulteImage;
                    const isAdded = addedToCart[id] ?? false;
                    const isAdding = addingToCartId === id;
                    const qty = getQuantity(id);

                    return (
                      <div className={`uc2-card-hvu ${outOfStock ? "uc2-card-nostock-hvu" : ""}`} key={id}>
                        <div className="uc2-img-zone-hvu">
                          <img
                            src={finalImg}
                            alt={pro.Designation}
                            className={`uc2-img-hvu ${outOfStock ? "uc2-img-grey-hvu" : ""}`}
                          />
                          <span className="uc2-brand-chip-hvu">{pro.NomMarque ? pro.NomMarque : "Pièce"}</span>
                          {outOfStock ? (
                            <div className="uc2-stock-badge-hvu uc2-stock-out-hvu">
                              <i className="bi bi-x-circle-fill" /> Stock épuisé
                            </div>
                          ) : (
                            <div className="uc2-stock-badge-hvu uc2-stock-in-hvu">
                              <i className="bi bi-check-circle-fill" /> En stock
                            </div>
                          )}
                        </div>

                        <div className="uc2-body-hvu">
                          <div className="uc2-stars-hvu">
                            {[...Array(5)].map((_, i) => (
                              <i key={i} className="bi bi-star-fill uc2-star-i-hvu" />
                            ))}
                          </div>

                          <Link className="uc2-title-link-hvu" to={`/clients/${idClient}/articles/${pro.IdArticle}`} state={{ article: pro }}>
                            <div className="uc2-title-hvu">
                              {pro.Designation}
                            </div>
                          </Link>

                          <div className="uc2-ref-badge-wrap">
                            <span className="uc2-ref-badge" title={`Réf: ${pro.RefArticle || pro.reference || pro.Reference || pro.ref || ''}`}>
                              <i className="bi bi-hash" /> Réf : {pro.RefArticle || pro.reference || pro.Reference || pro.ref || "N/A"}
                            </span>
                          </div>

                          {/* Prix block: two-price display */}
                          <div className="uc2-price-block-hvu">
                            {showOldPrice && rawHT > 0 && (
                              <div className="uc2-price-old-row-hvu">
                                <span className="uc2-price-old-hvu">
                                  {oldPrice.toFixed(2)} MAD
                                </span>
                                <span className="uc2-discount-badge-hvu">-{Math.round(clientRemise)}%</span>
                              </div>
                            )}
                            <div className="uc2-price-hvu">
                              {cleanPrice}
                              <span className="uc2-currency-hvu"> MAD</span>
                            </div>
                          </div>

                          {!outOfStock && (
                            <div className="uc2-cart-row-hvu mt-3">
                              <div className="uc2-qty-hvu">
                                <button
                                  className="uc2-qty-btn-hvu"
                                  onClick={e => { e.preventDefault(); changeQuantity(id, -1); }}
                                  aria-label="Moins"
                                >−</button>
                                <input
                                  className="uc2-qty-input-hvu"
                                  type="number"
                                  min={1}
                                  value={qty}
                                  onClick={e => e.preventDefault()}
                                  readOnly
                                />
                                <button
                                  className="uc2-qty-btn-hvu"
                                  onClick={e => { e.preventDefault(); changeQuantity(id, +1); }}
                                  aria-label="Plus"
                                >+</button>
                              </div>
                              <button
                                className={`uc2-add-btn-hvu ${isAdded ? "uc2-add-btn-done-hvu" : ""}`}
                                onClick={e => { e.preventDefault(); handleAddToCart(pro); }}
                                disabled={isAdding}
                                style={{ height: '36px', fontSize: '0.78rem' }}
                              >
                                {isAdding
                                  ? <><span className="btn-spinner-hvu" /> ...</>
                                  : isAdded
                                  ? <><i className="bi bi-check-lg" /> Ajouté</>
                                  : <><i className="bi bi-cart-plus" /> Ajouter</>}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                    <button
                      className="btn btn-sm btn-outline-warning px-3"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{ borderRadius: '8px' }}
                    >
                      Précédent
                    </button>
                    <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                      Page <strong>{currentPage}</strong> sur {totalPages}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-warning px-3"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{ borderRadius: '8px' }}
                    >
                      Suivant
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-5 border rounded bg-white">
                <i className="bi bi-emoji-neutral text-muted" style={{ fontSize: '2.5rem' }}></i>
                <h5 className="mt-3 text-dark">Aucun produit trouvé</h5>
                <p className="text-muted">Essayez avec une autre référence ou un autre mot-clé.</p>
              </div>
            )}
          </>
        )}
      </main>

      {/* ===== FLOATING ACTION BUTTONS ===== */}
      <div className="client-floating-actions">
        {cartLength > 0 && (
          <div className="client-floating-timer">
            <Timer userId={ClientId || ""} userType="client" asFloating={false} />
          </div>
        )}
        <Link to={`/clients/${ClientId}/assistance`} className="client-floating-btn support-btn">
          <i className="bi bi-headset"></i>
        </Link>
      </div>

      {/* Floating Bug Report Button (Left Side) */}
      <BugReportButton />
    </div>
  );
}
